import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=1efe64ea&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=1efe64ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe64ea",
  null
  
)

export default component.exports